// src/components/Admin/Auth/ForgotPasswordForm.js
import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { Auth } from "../../../../api/auth";
import { toast, ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";
import "./AuthForms.scss";
import { logoEduca } from "../../../../assets"; // tu logo

export function ForgotPasswordForm() {
  const [loading, setLoading] = useState(false);
  const authController = new Auth();
  const { t } = useTranslation("auth");

  const getSchema = (t) =>
    Yup.object({
      email: Yup.string()
        .email(t("forgotPassword.emailInvalid"))
        .required(t("forgotPassword.required")),
    });

  const formik = useFormik({
    initialValues: { email: "" },
    validationSchema: getSchema(t),
    onSubmit: async ({ email }) => {
      try {
        setLoading(true);
        await authController.forgotPassword(email);
        toast.success(t("forgotPassword.successMessage"));
      } catch (err) {
        toast.error(err.message || t("forgotPassword.errorMessage"));
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <div className="auth-container">
      <div className="auth-card">
        {/* Logo de Educa360 */}
        <img src={logoEduca.logoE360} alt="Educa360" className="auth-logo" />

        {/* El propio formulario */}
        <ToastContainer />
        <form className="auth-form" onSubmit={formik.handleSubmit}>
          <div className="input-group">
            <input
              name="email"
              type="email"
              placeholder={t("forgotPassword.emailPlaceholder")}
              className="input-pill"
              value={formik.values.email}
              onChange={formik.handleChange}
            />
            {formik.touched.email && formik.errors.email && (
              <div className="field-error">{formik.errors.email}</div>
            )}
          </div>
          <button type="submit" className="btn-pill" disabled={loading}>
            {loading ? t("forgotPassword.sending") : t("forgotPassword.submitButton")}
          </button>
        </form>

        {/* Link para volver al login */}
        <div className="auth-switch" style={{ marginTop: "1rem" }}>
          <Link to="/auth" className="link-btn">
            ← {t("forgotPassword.backToLogin")}
          </Link>
        </div>
      </div>
    </div>
  );
}
